import React, { useState } from 'react';
import classNames from 'classnames';
import { sortSelectedLayersInTypes } from '../helpers/zipCodeParser';
import './selected-filters.scss';

const RenderText = props => {
    const [isFullLength, toggleLength] = useState(false);
    let txt = props.filters.map(f => f.name ? f.name : f).join(', ');
    
    if (txt.length > 250 && !isFullLength) {
        txt = `${txt.substring(0, 250)}...`;
    }

    return (
        <>
            <p className={classNames({
                'selected-filters__text': true,
                'selected-filters__text--is-full': isFullLength
            })}>{txt}
                {props.filters.join(', ').length > 250 &&
                    <button type="button" 
                            onClick={() => toggleLength(!isFullLength)}
                            className="selected-filters__toggler">Visa {isFullLength ? 'mindre' : 'mer'}</button>
                }
            </p>
        </>
    );
};

const Filter = props => {
    return (
        <div className="selected-filters__filter">
            <h2 className="selected-filters__heading">{props.heading}</h2>
            <RenderText filters={props.filters} />
        </div>
    );
};

const SelectedFilters = props => {
    
    if (!props) return null;
    
    const { layerSelection } = props;
    const sortedByTypes = sortSelectedLayersInTypes(layerSelection)

    return (
        <div className="selected-filters">
            {sortedByTypes['zip1'] && sortedByTypes['zip1'].length > 0 &&
                <Filter heading="1-siffriga postnummer:" filters={sortedByTypes['zip1']} />
            }
            {sortedByTypes['zip2'] && sortedByTypes['zip2'].length > 0 &&
                <Filter heading="2-siffriga postnummer:" filters={sortedByTypes['zip2']} />
            }
            {sortedByTypes['zip3'] && sortedByTypes['zip3'].length > 0 &&
                <Filter heading="3-siffriga postnummer:" filters={sortedByTypes['zip3']} />
            }
            {sortedByTypes['zip5'] && sortedByTypes['zip5'].length > 0 &&
                <Filter heading="5-siffriga postnummer:" filters={sortedByTypes['zip5']} />
            }
            {layerSelection.locality && layerSelection.locality.length > 0 &&
                <Filter heading="Postort:" filters={layerSelection.locality} />
            }
            {layerSelection.municipality && layerSelection.municipality.length > 0 &&
                <Filter heading="Kommuner:" filters={layerSelection.municipality} />
            }
            {layerSelection.county && layerSelection.county.length > 0 &&
                <Filter heading="Län:" filters={layerSelection.county} />
            }
            {layerSelection.aregion && layerSelection.aregion.length > 0 &&
                <Filter heading="A-regioner:" filters={layerSelection.aregion} />
            }
        </div>
    );
};

export default SelectedFilters;